import { Flex } from '@chakra-ui/react';
import { connect } from 'react-redux';

import Spinner from 'components/Spinner';
import { HEADER_HEIGHT, HEADER_HEIGHT_V1 } from 'projectConstants';

interface Properties {
  isLoading: boolean;
  uiRevamp?: boolean;
}

const SharedLoader = ({ isLoading, uiRevamp }: Properties) => {
  const headerHeight = (uiRevamp ? HEADER_HEIGHT_V1 : HEADER_HEIGHT) as string;
  const height = `calc(100vh - ${headerHeight})`;
  if (!isLoading) return <></>;
  return (
    <Flex
      zIndex='1000'
      bg={'gradient.body'}
      position='fixed'
      top={headerHeight}
      width='100%'
      height={height}
      display='flex'
      justifyContent='center'
      alignItems='center'
    >
      <Spinner />
    </Flex>
  );
};

const stateToProperty = (state: any) => {
  return { isLoading: state?.sharedSlice?.loading };
};

export default connect(stateToProperty)(SharedLoader);
